import styled from 'styled-components';

export const Paragraph = styled.div`
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
`;
